import { render, staticRenderFns } from "./AltaUsuario.vue?vue&type=template&id=3c110bbe"
import script from "./AltaUsuario.vue?vue&type=script&lang=js"
export * from "./AltaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports